import React, { Component, useContext } from 'react';
import Axios from 'axios';

import { PageHeader,  Button, Form, Input, Divider, Select, Rate, InputNumber, Row, Col, message } from 'antd';
import {
     SaveOutlined
} from "@ant-design/icons";
import { BaseContext } from '../BaseContext';

const CreateMovie = () => {
    const { token, setToken, setUser, setEmail } = useContext(BaseContext);

    const { Option } = Select;
    const genres = ['Action', 'Adventures', 'Animation', 'Comedy', 'Crime', 'Documentary', 'Drama', 'Family', 'Fantasy', 'Horor', 'Music', 'Mystery', 'Sci-fi', 'Tv Movie', 'War', 'Western'];


    const onFinish = (values) => {
        let newMovie = values;
        newMovie.genre = newMovie.genre.join(', ');
        
        Axios.post('https://backendexample.sanbersy.com/api/data-movie',
            newMovie,
            { headers: { Authorization: `Bearer ${token}` } }
        ).then(() => {
            window.history.back();
            message.success("Movie Successfully added");
        }).catch(err => {
            try {
                if (err.response.data.status.includes('Token')) {
                    message.error('Token Expired , Please Log in Again!!');
                    setToken("");
                    setUser("");
                    setEmail("");
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    localStorage.removeItem("email");
                }
            } catch (err) {
                window.history.back();
                message.error('error in creating data API, please try again later!');
            }
        }

        )
    };



    return (
        <div style={{ padding: "0" }}>
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Back"
                style={{ minHeight: "92vh" }}
            >

                <Divider style={{ marginTop: "1vh" }} />
                <h2 style={{ textAlign: "center", marginBottom: "5vh" }}>Create Movie</h2>
                <Form
                    name="basic"
                    initialValues={{
                        ['year']: 2020,

                    }}
                    onFinish={onFinish}

                >
                    <Form.Item
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        label="Movie Title"
                        name="title"
                        placeholder="please input movie title"
                        rules={[{ required: true, message: 'Please input movie title' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        name="genre"
                        label="Select Genre"
                        rules={[{ required: true, message: 'Please select movie genre!', type: 'array' }]}
                    >
                        <Select mode="multiple" placeholder="Please select movie genre!">
                            {genres.map(genre => <Option value={genre}>{genre}</Option>)}

                        </Select>
                    </Form.Item>

                    <Form.Item name="rating" label="Movie Rating"
                        rules={[{ required: true, message: 'Please input movie rating!' }]}
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}>
                        <Rate count={10} character={({ index }) => {
                            return index + 1;
                        }} style={{ fontSize: "1.4rem" }} />
                    </Form.Item>

                    <Form.Item label="Release Year" labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        required={true}
                    >
                        <Form.Item name="year" noStyle rules={[{ required: true, message: 'Please input release year!' }]}>
                            <InputNumber min={1950} />
                        </Form.Item>
                        <span className="ant-form-text"></span>
                    </Form.Item>


                    <Form.Item label="Movie Duration" labelCol={{ span: 3 }} required={true}
                        wrapperCol={{ span: 9 }}>
                        <Form.Item name="duration" noStyle rules={[{ required: true, message: 'Please input movie duration!' }]}>
                            <InputNumber min={1} />
                        </Form.Item>
                        <span className="ant-form-text"> Minutes</span>
                    </Form.Item>


                    <Form.Item name="description" label="Introduction" labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        rules={[{ required: true, message: 'Please input movie description' }]}
                    >
                        <Input.TextArea />
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        label="Image Url"
                        name="image_url"
                        placeholder="please input movie title"
                        rules={[{ required: true, message: 'Please input movie image url    ' }]}
                    >

                        <Input />
                    </Form.Item>

                    <Row>
                        <Col style={{ marginTop: "4vh" }}>
                            <Button type="primary" htmlType="submit" >
                                <SaveOutlined /> Save Movie
                        </Button>
                        </Col>
                    </Row>
                </Form>

            </PageHeader>
        </div>
    )
}

export default CreateMovie;